// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TvInteriorIdCache } from './TvInteriorIdCache';
import { DataCache } from '../../DataCache';
class _TvPipsValuesCache {
    constructor() {
        this.subscibtionMap = new Map();
    }
    subscribePipValue(symbol) {
        const interiorId = TvInteriorIdCache.getInteriorId(symbol);
        const instrument = DataCache.getInstrumentByName(interiorId);
        if (isNullOrUndefined(instrument))
            return;
        if (!this.subscibtionMap.has(symbol)) {
            const container = new PipValuesInfoContainer(instrument);
            this.subscibtionMap.set(symbol, container);
        }
    }
    unsubscribePipValue(symbol) {
        if (this.subscibtionMap.has(symbol)) {
            this.subscibtionMap.delete(symbol);
        }
    }
    updateSubscribedPipValues(host, account) {
        this.subscibtionMap.forEach((value, key) => {
            const instrument = value.instrument;
            const pipSize = instrument.PipsSize;
            const crossPriceToAccountCurrency = DataCache.CrossRateCache.GetCrossPriceExp1Exp2(instrument.Exp2, account.BaseCurrency, account);
            const ticCost = instrument.GetTickCost();
            const pipValue = pipSize * ticCost * crossPriceToAccountCurrency;
            // const prevPipValue = value.prevPipValue;
            // if (pipValue !== prevPipValue) {
            const pipValues = {
                buyPipValue: pipValue,
                sellPipValue: pipValue
            };
            host.pipValueUpdate(key, pipValues);
            // }
            // value.prevPipValue = pipValue;
        });
    }
}
class PipValuesInfoContainer {
    constructor(instrument) {
        this.prevPipValue = 0;
        this.instrument = instrument;
    }
}
export const TvPipsValuesCache = new _TvPipsValuesCache();
